import { useMainContext } from '@/lib/context';
import { getAutocompleteOptions } from '@/lib/getResults';
import { AutocompleteOption } from '@/lib/model';
import * as React from 'react';
import { MainComponent } from './MainComponent';
import ComuneAlBallottaggio from '@/data/getlisteB.json';

export const Main = () => {
  const { setComuneIsLoading, setSearchResult } = useMainContext();

  // Function used when pressing an option within searched results
  const onOptionPress = async (result: AutocompleteOption) => {
    setComuneIsLoading(true);

    // set search result and activate useEffect defined above
    setSearchResult(result);
  };

  const inputOptions = getAutocompleteOptions();

  // selezione del comune di default quando si apre la mappa
  React.useEffect(() => {
    // @ts-ignore
    const defaultValue = window['DEFAULT_SELEZIONE_MAPPA'];

    if (!defaultValue) {
      return;
    }

    const { codRegione, codProvincia, codComune, ballottaggio } =
      defaultValue;

    if (codComune && codProvincia && codRegione) {
      const secondBallot = ComuneAlBallottaggio.find(c => +c.r === +codRegione && +c.p === +codProvincia && +c.c == +codComune) !== undefined
      const codes: AutocompleteOption = {
        codCom: codComune,
        codProv: codProvincia,
        codReg: codRegione,
        nameComune: "",
        nameProvincia: "",
        nameRegione: "",
        secondBallot: ballottaggio || secondBallot
      };
  
      setSearchResult(codes);
    }
  }, []);

  return (
    <MainComponent inputOptions={inputOptions} onOptionPress={onOptionPress} />
  );
};
